const resume = {
  name: "Edward Oluyara",
  job_title: "Full Stack Web Developer",
  summary_title: "Summary",
  summary:
    "My name is Edward Oluyara. I am a full stack web developer and enjoy creating web features using HTML, CSS, Bootstrap, React/Redux and Ruby on Rails as a stack. I recently graduated from Microverse, an online school and now I am seeking my first opportunity to work as a developer.",
  skills_title: "Skills",
  experience_title: "Experience",
  highlight: "Highlighted Personal Projects",
  job_field: "Full Stack Web Developer",
  type: "Remote",
  date: "August, 2020 - Present",
  microverse: "Microverse",
  job_experience: "Mentor",
  type_2: "Remote",
  date_2: "December, 2021 - Present",
  list: [
    "Mentoring junior web developers, providing technical support through code reviews.",
    "Proposing improvements to code organization to improve code quality and overall performance.",
    "Providing advice and tips on how to maintain motivation to maintain longevity in the program.",
    "Formed a group team to gather ideas on how to build a bigger project to support the Dev community.",
  ],
};

const experience = [
  {
    title: "Todo App",
    description:
      "This is a todo list app that can add tasks and remove completed tasks from a listed event.",
    built_with: "Built with: (HTML, CSS, JavaScript and Webpack)",
  },
  {
    title: "Task Tracker App",
    description:
      "This is a project that keeps track of your event in a day or a month and customizes them to help you achieve your tasks in a timely manner.",
    built_with: "Built with: (React, CSS and JSON-server)",
  },
  {
    title: "Web Calculator",
    description: "This is a simple calculator app that I built with React.",
    built_with: "Built with: (HTML, Bootstrap, Webpack, CSS and React)",
  },
  {
    title: "Pocket Smith App",
    description:
      "This is a mobile web application where you can manage your budget and see a list of transactions associated with a category. Users can see how much money they have spent and on what item they spent their money on.",
    built_with:
      "Built with: (Ruby on Rails, Postgres, Javascript and Bootstrap)",
  },
  {
    title: "Catalogs Of My Things",
    description:
      "In this project, we as a group have created a console app that will help you to keep a record of different types of things you won: books, music albums, movies, and games",
    built_with: "Built with: (Ruby)",
  },
  {
    title: "Bcycom App",
    description: "This is the back end I built to store motorcycles",
    built_with: "Built with: (Ruby on Rails, Postgres, jwt-authentication)",
  },
];

const social_links = {
  github: "https://github.com/oluyaratosin123",
  email: "oluyaratosin123@gmail.com",
  linkedin: "https://www.linkedin.com/in/edward-oluyara-708b88215/",
  twitter: "https://twitter.com/TOluyara",
  angelList: "https://angel.co/u/edward-yara",
};

const education = {
  title: "Education",
  school: "Microverse",
  field_of_study: "Remote Full Stack Web Development Program, Full Time",
  date_3: "October, 2021 - Present",
  list_2: [
    "Spent 1300+ hours mastering algorithms, data structures, and full-stack web development while simultaneously developing projects with JavaScript, React, and Redux.",
    "Developed skills in remote pair-programming using GitHub, industry-standard gitflow, and daily standups to communicate and collaborate with international remote developers.",
  ],
};

const resume_skills_lists = [
  "FRONTEND: JavaScript, React, HTML5, CSS3",
  "BACKEND: Ruby on Rails",
  "DATABASE: PostgreSQL",
  "TOOLS & METHODS: Git, GitHub, Heroku, Mobile,/Responsive Development, TDD, Chrome Dev Tools",
  "PROFESSIONAL: Remote Pair-Programming, Teamwork, Mentoring",
];

export { resume, experience, social_links, education, resume_skills_lists };
